
import { useParams } from 'react-router-dom';
import { ClienteState } from '../../../context/cliente/ClienteState';
import { DatagridFavoritos } from './datagridFavoritos';

export const ClienteFavoritosPage = () => {
  const { id } = useParams(); 

  return (
    <ClienteState>
        <br />
        <DatagridFavoritos title="Favoritos" />
    </ClienteState>
  );
};
